<template lang="pug">
section.loyalty-id-dropdown
  div.loyalty-id-dropdown__contentMenu
    div.loyalty-id-dropdown__actionMenu
      ods-select(
        v-model="dropText")
          ods-option(
            v-for="item in optionsMenu"
            :key="item.value"
            :label="item.label"
            :value="item.value")
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'IdDropdown',
  data: () => {
    return {
      optionsMenu: [],
      dropText: null
    }
  },
  methods: {
    ...mapActions(['getIdDropdown']),
    convertSelectioData (data) {
      const options = []
      for (const i in data) {
        options.push({
          label: data[i].desctidc,
          value: data[i].tipidext
        })
      }
      return options
    }
  },
  async mounted () {
    const response = await this.getIdDropdown()
    this.optionsMenu = this.convertSelectioData(response.registros)
  }
}
</script>
<style lang="scss">
.loyalty-id-dropdown{
  display: flex;
  flex-direction: column;

  &__contentMenu{
   background-color: #FFFFFF;
  }

  &__actionMenu{
    display: flex;
  }
}
</style>
